export const feebackTextConfig = {
  positive: {
    feedback: [
      "That sounds nice",
      "Wonderful! I love that energy",
      "That's absolutely delightful",
      "You're on fire today!",
      "That made me smile",
      "Brilliant! Keep it up",
      "That's the spirit!",
      "You're crushing it!",
      "That's fantastic news",
      "I'm genuinely impressed"
    ],
    ctaText: "Have more fun",
    score: 100
  },
  negative: {
    feedback: [
      "Ah ! That's bleak",
      "That's quite depressing",
      "Ouch, that hurts to hear",
      "That's a tough situation",
      "I'm sorry you're going through that",
      "That sounds really difficult",
      "That's heartbreaking",
      "That's not what I wanted to hear",
      "That's quite concerning",
      "That's a real downer"
    ],
    ctaText: "Do Better",
    score: 20
  },
  neutral: {
    feedback: [
      "Your point is taken",
      "I understand what you mean",
      "That's an interesting perspective",
      "I see where you're coming from",
      "That's fair enough",
      "I get it",
      "That makes sense",
      "I hear you",
      "That's a valid point",
      "I can see that"
    ],
    ctaText: "Start Fresh",
    score: 50
  },
  mixed: {
    feedback: [
      "Not sure what that means. Sarcasm ?",
      "I'm confused by that response",
      "That's... interesting",
      "I'm not sure how to take that",
      "That's a bit ambiguous",
      "I'm puzzled by that",
      "That's unclear to me",
      "I'm not following",
      "That's a mixed signal",
      "I'm not sure what to make of that"
    ],
    ctaText: "Clarify",
    score: 75
  }
};
